import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {NavigationExtras, Router} from '@angular/router';
import * as moment from 'moment';
import {CardUpcomingEvents} from '../../upcoming-events-card/card-upcoming-events';

@Component({
    selector: 'app-event-details-modal',
    templateUrl: './event-details-modal.component.html',
    styleUrls: ['./event-details-modal.component.css']
})
export class EventDetailsModalComponent implements OnInit {
    events = [];
    selectedDate;
    constructor(private matDialogRef: MatDialogRef<EventDetailsModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router) {
    }

    ngOnInit() {
        this.events = this.data.events;
        this.selectedDate = moment(this.data.date, 'MM/DD/YYYY').format('dddd, MMMM D, YYYY');
    }

    closeClick() {
        this.matDialogRef.close();
    }

    goToCalendarClick() {
        this.closeClick();
        const navigationExtras: NavigationExtras = {
            // needs to be lower case view, day, week, month
            queryParams: {
                'selectedView': 'month'
            }
        };
        this.router.navigate(['/student360/calendar'], navigationExtras);
    }

    multiDayEvent(event) {
        // check if the event is a multi day event
        if (event.EventStartDate == event.EventEndDate) {
            return false;
        } else {
            return true;
        }
    }

    getDateRangeString(event) {
        const startDate = moment(event.EventStartDate, 'MM/DD/YYYY hh:mm:ss A').format('MMM DD');
        const endDate = moment(event.EventEndDate, 'MM/DD/YYYY hh:mm:ss A').format('MMM DD');
        return startDate + ' - ' + endDate;
    }

    hasTimeLocation(event) {
        if (event.EndTime || event.StartTime || event.EventLocation) {
            return true;
        } else {
            return false;
        }
    }

    getTimeLocationString(event: CardUpcomingEvents) {
        let eventStartTime = '';
        let eventEndTime = '';
        const location = event.EventLocation;

        if (event.StartTime) {
            eventStartTime = moment(event.StartTime, 'HH:mm:ss').format('h:mm A');
        }
        if (event.EndTime) {
            eventEndTime = moment(event.EndTime, 'HH:mm:ss').format('h:mm A');
        }
        if (eventStartTime && eventEndTime && location) { // Has StartTime, EndTime and Location
            return eventStartTime + ' - ' + eventEndTime + ', ' + location;
        }
        if (!eventStartTime && !eventEndTime && !location) { // Has no start time, end time or location
            return '';
        }
        if (eventStartTime && !eventEndTime && !location) { // Only a StartTime
            return eventStartTime;
        }
        if (!eventStartTime && eventEndTime && !location) { // Only a EndTime
            return 'Until ' + eventEndTime;
        }
        if (!eventStartTime && !eventEndTime && location) { // Only a Location
            return location;
        }
        if (eventStartTime && !eventEndTime && location) { // Has StartTime and Location
            return eventStartTime + ', ' + location;
        }
        if (!eventStartTime && eventEndTime && location) { // Has EndTime and Location
            return 'Until ' + eventEndTime + ', ' + location;
        }
        if (eventStartTime && eventEndTime && !location) { // Has StartTime and EndTime
            return moment(eventStartTime, 'HH:mm:ss').format('h:mm A') + ' - ' + eventEndTime;
        }
    }

}
